export var GameConst;
(function (GameConst) {
    class config {
    }
    GameConst.config = config;
    GameConst.isConst = true;
    GameConst.path = "res/config/GameConst.json";
})(GameConst || (GameConst = {}));
